// Follow-up settings per quote type (batch 3). A type's own value wins; an empty one means "use the default".
// Decision 3 (BE7): the no-reply escalation is gone, so a type's own silence days and "who is told" are neither shown
// nor sent (the PUT is partial: the stored values stay).

export const CHASE_CALL_OPTIONS = [
  { value: 'AUTO', label: 'Only while this type\'s emails are off (recommended)' },
  { value: 'ALWAYS', label: 'Always' },
  { value: 'NEVER', label: 'Never' }
]

const CHASE_CALL_SHORT = { AUTO: 'While emails off', ALWAYS: 'Always', NEVER: 'Never' }

/** "7, 21 days" from the type's step days; "no steps" when it has none. */
export function stepDaysText(days) {
  var d = (days || []).filter(n => n !== null && n !== undefined)
  return d.length ? d.join(', ') + ' days' : 'no steps'
}

/** One row of the Quote types table, from GET v1/followupTypes. */
export function typeRow(t) {
  return {
    projectTypeId: t.projectTypeId,
    name: t.name,
    emails: t.emailsOn ? 'On' : 'Off',
    steps: (t.ownSteps ? 'Own: ' : 'Default: ') + stepDaysText(t.stepDays),
    chaseCall: CHASE_CALL_SHORT[t.chaseCallOnBooking] || ''
  }
}

/** The edit form's model. */
export function toTypeForm(t) {
  var x = t || {}
  return {
    emailsOn: !!x.emailsOn,
    ownSteps: !!x.ownSteps,
    chaseCallOnBooking: x.chaseCallOnBooking || 'AUTO'
  }
}

/** The form as the PUT body. */
export function toTypePayload(f) {
  return {
    emailsOn: !!f.emailsOn,
    ownSteps: !!f.ownSteps,
    chaseCallOnBooking: f.chaseCallOnBooking || 'AUTO'
  }
}
